module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-87.48fbac70.svg";